import { Paragraph } from '@hungryroot/ramen';
import styles from './HealthMetricsFootnotes.module.css';

export function HealthMetricsFootnotes() {
  return (
    <ol className={styles['list']}>
      <li>
        <Paragraph variant="caption-xs">
          1. Of customers surveyed who reported having the goal of improving
          digestion, cholesterol, blood pressure, blood sugar, immunity,
          inflammation, muscle tone, stress, focus, bloating, energy, skin and
          hair health, or sleep.
        </Paragraph>
      </li>
      <li>
        <Paragraph variant="caption-xs">
          2. Of customers surveyed who reported having that goal.
        </Paragraph>
      </li>
    </ol>
  );
}
